import { render, staticRenderFns } from "./MessageNav.vue?vue&type=template&id=71a67360&scoped=true&"
import script from "./MessageNav.vue?vue&type=script&lang=js&"
export * from "./MessageNav.vue?vue&type=script&lang=js&"
import style0 from "./MessageNav.vue?vue&type=style&index=0&id=71a67360&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a67360",
  null
  
)

export default component.exports